import { shallowMount } from "@vue/test-utils";
import AddressSelector from "@/components/core/custom/domicilio/AddressSelector";

describe("AddressSelector component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(AddressSelector, {
      propsData: {
        value: "",
        particular: {},
        otro: {}
      }
    });
  });

  it("Renders del component AddressSelector", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
